import { AutocompleteInput, useDataProvider } from "react-admin";
import { FC, useEffect, useState } from "react";

interface SchoolCodeInputProps {
  alwaysOn?: boolean;
}

const SchoolCodeInput: FC<SchoolCodeInputProps> = () => {
  const [data, setData] = useState([]);

  const provider = useDataProvider();

  const fetchSchools = async () => {
    const response = await provider.getList("schools", {
      filter: { MbcRegisteredOnly: true },
      sort: {
        field: "schoolPrefix",
        order: "ASC",
      },
      pagination: {
        page: 1,
        perPage: 1000,
      },
    });
    setData(
      response.data.map((item: any) => ({
        id: item.schoolPrefix,
        name: item.name,
      })),
    );
  };

  useEffect(() => {
    fetchSchools();
  }, []);

  return (
    <AutocompleteInput
      source="SchoolCode"
      choices={data}
      optionText={(choice: any) =>
        choice.id ? `${choice.id} - ${choice.name}` : ""
      }
      allowEmpty
    />
  );
};

export default SchoolCodeInput;
